import React from 'react';
import { useHistory } from 'react-router-dom';
import { t } from 'i18next';

const Error404 = () => {
  const history = useHistory();

  return (
    <div className="error-wrap">
      <div className="container-error">
        <strong className="txt-error">{t('요청하신 페이지를 찾을 수 없습니다.')}</strong>
        <span className="txt-desc">{t('변경 혹은 삭제된 주소일 수 있습니다. 주소를 다시 확인해 주세요.')}</span>
        <button type="button" className="btn-primary" onClick={() => history.push('/')}>
          {t('홈으로 가기')}
        </button>
      </div>
    </div>
  );
};

export default Error404;
